import { FileText, EyeOff, Wallet, KeyRound } from "lucide-react";
import { TokenDemo } from "./TokenDemo";
import { usePricing, inr } from "./usePricing";

const walletText = (p) => {
  if (p.mode === "free") return "Currently free — no wallet balance, unlock fee or placement fee is needed.";
  const fees = p.placement_fee > 0 ? `Each unlock (${inr(p.unlock_fee)}) or placement (${inr(p.placement_fee)})` : `Each contact unlock (${inr(p.unlock_fee)})`;
  return `Keep a wallet balance (e.g. ${p.wallet_options.map(inr).join(" / ")}). ${fees} is auto-deducted and logged.`;
};

const stepsFor = (p) => [
  { Icon: FileText, title: "Post requirement", desc: "Headcount, shift, pay structure and facilities — scoped to your state and district." },
  { Icon: EyeOff, title: "Masked match", desc: "See matched profiles with numbers hidden. Click “Request Contact / Issue Job Token” to unlock." },
  { Icon: Wallet, title: p.mode === "free" ? "Free access" : "Prepaid wallet", desc: walletText(p) },
  { Icon: KeyRound, title: "Joining OTP", desc: "On reporting day the employee shares a 4-digit OTP with you to mark official placement." },
];

export const HowItWorks = () => {
  const pricing = usePricing();
  return (
  <section id="how-it-works" className="scroll-mt-20 bg-[#0B1120] py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-6">
        <p className="eyebrow">How it works</p>
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-white lg:text-3xl">From requirement to verified placement.</h2>
        <ol className="mt-7 space-y-3">
          {stepsFor(pricing).map(({ Icon, title, desc }, i) => (
            <li key={title} data-testid={`how-step-${i + 1}`} className="flex gap-4 rounded-xl border border-white/10 bg-[#0F172A] p-4">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-orange-500 font-mono text-sm font-bold text-white">{i + 1}</span>
              <div>
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-white"><Icon className="h-4 w-4 text-orange-400" />{title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-slate-400">{desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
      <div className="lg:col-span-6 lg:self-center"><TokenDemo pricing={pricing} /></div>
    </div>
  </section>
  );
};
